import React, { useEffect } from 'react';
import QuestionTemplateList from '../components/QuestionTemplates/QuestionTemplateList';

const QuestionTemplatesPage: React.FC = () => {
    useEffect(() => {
        console.log('QuestionTemplatesPage mounted');
    }, []);
    
    return <QuestionTemplateList />;
};

export default QuestionTemplatesPage;